import * as React from "react"
import Link from './link'
import { GatsbyImage } from "gatsby-plugin-image"

const TeamMembers = ({ members }) => {
  return (
    <div className='team--members grid p10'>
      {members.map((member, index) => {
        return (

          <div key={index} >
            <div className='ratio-1-2 pos-rel bg-dark overflow-hidden'>
              <GatsbyImage className='bg-image' image={member.image?.gatsbyImageData} alt="" />
            </div>
            <div className="information flex mt10">
              <div className="w-50 mla uppercase">
                <p className='m0  text-light'>{member.name}</p>
                <p className='m0 text-light '>{member.role}</p>
                {(member.subrole ? <p className='m0 text-normal'>({member.subrole})</p> : '')}
              </div>
            </div>
          </div>

        )
      })}
    </div>
  )
}
export default TeamMembers
